export class Brand {
  id: number;
  name: string;
  idExternal: number;
}
